<script>
	import { convert } from "src/services/helpers";
	import { caseOriginOptions } from "src/utils/options";
	import { navigate } from "svelte-routing";
	import { Col, Row } from "@sveltestrap/sveltestrap";

	export let caseDetails = {};
	export let state = "view"; // possible values: "view", "edit"
</script>

<div class="p-0">
	<Row>
		<Col class="col-4">
			<div class="description">Case Number</div>
			<div class="value">{caseDetails.caseNo}</div>
		</Col>
		<Col class="col-4">
			<div class="description">Case Origin</div>
			<div class="value">
				{caseOriginOptions.find(
					(option) => option.value === caseDetails.caseOrigin
				)?.label || "-"}
			</div>
		</Col>
		<Col class="col-4">
			<div class="description">Case Created By</div>
			<div class="value">
				{caseDetails.createdBy || caseDetails.lastReviewedBy}
			</div>
		</Col>
	</Row>

	<hr class="divider" />

	<Row>
		<Col class="col-4">
			<div class="description">Case Created At</div>
			<div class="value">
				{convert(caseDetails.createdAt) ||
					convert(caseDetails.lastReviewedAt)}
			</div>
		</Col>
		{#if state !== "edit" && caseDetails.status !== "Quoting"}
			<Col class="col-4">
				<div class="description">Zendesk Ticket ID</div>
				<div class="value">
					{caseDetails.ticketId || "-"}
				</div>
			</Col>
			<Col class="col-4">
				<div class="description">Linked Cases</div>
				<div class="value">
					{#if caseDetails.linkToCase}
						{#each caseDetails.linkToCase as cases, i}
							<span
								key={`${cases}-${i}`}
								class="link link-text"
								on:click={navigate(
									`/issues/case-management?tab=&caseNo=${cases}`
								)}
								on:keydown={() => {}}
								>{cases}{`${
									i < caseDetails.linkToCase.length - 1
										? ", "
										: ""
								}`}</span
							>
						{/each}
					{:else}
						<span>-</span>
					{/if}
				</div>
			</Col>
		{/if}
	</Row>
	{#if caseDetails.status === "Closed"}
		<hr class="divider" />
		<Row>
			<Col class="col-8">
				<div class="description">Reason for closing case</div>
				<div class="value">
					{caseDetails.rejectedClosedReason || "-"}
				</div>
			</Col>
		</Row>
	{/if}
</div>
